module.exports = __webpack_public_path__ + "assets/img/03d3788b14b92ac64d5104ee70841680.png";